export default {
  message: {
    loading: 'Загрузка'
  },
  verbs: {
    url_copied: 'Ссылка скопирована',
    save: 'Сохранить',
    close: 'Закрыть',
    error: 'Ошибка',
    try_again: 'Попробуйте еще раз',
    download: 'Скачать',
    history: 'История',
    apply: 'Применить',
    invalid_parameters: 'Неверные параметры',
    manager: 'Менеджер',
    edit: 'Внести изменения?',
    add_product: 'Добавить заказ',
    total: 'Количество заказов',
    without: 'Без курьерки',
    unsent: 'Неотправленные',
    statusFilter: 'Фильтр',
    statusStop: 'Стоп'
  },
  auth: {
    login_action: 'Войти',
    login: 'Авторизация',
    password: 'Пароль',
    password_repeat: 'Пароль еще раз',
    account: 'Аккаунт',
    profile: 'Профиль',
    logout: 'Выход',
    old_password: 'Старый пароль',
    key: 'Введите код'
  },
  filter: {
    webmaster_grid: 'Веб-мастер (по сеткам)',
    webmaster: 'Веб-мастер'
  },
  statistic: {
    traffic: 'Трафик',
    ad_approved: 'Реклама',
    ad_pre_approved: 'Реклама предапрува',
    ad_difference: 'Разница реклам',
    ad_approve_percent: '% апрува',
    day: 'День',
    last_update: 'Последнее обновление',
    last_version: 'Текущая версия',
    averageBill: 'Средний чек',
    averageBillLocal: 'Средний чек (местный)',
    averageBuyback: 'Средний чек выкупа',
    averageBuybackLocal: 'Средний выкуп (местный)',
    average_x_price: 'x от нач.цены',
    approve: 'Апрув',
    approvedFromValid: 'Арув от валида',
    approved: 'Подтверждено',
    leads: 'Лиды',
    quantity: 'Количество',
    holds: 'Холды',
    offers: 'Офферы',
    offer: 'Оффер',
    filters: 'Фильтры',
    adult: 'Адалт',
    slimming: 'Похудение',
    beauty: 'Красота',
    health: 'Здоровье',
    economizers: 'Экономайзеры',
    lowPrice: 'Лоу Прайс',
    hair: 'Волосы',
    sport: 'Спорт',
    other: 'Прочее',
    date: 'Дата',
    total: 'Всего',
    processed: 'В обработке',
    accepted: 'Одобрено',
    canceled: 'Отменено',
    canceled_by_reason: 'Отменено по причине',
    canceledPercents: 'Отменено %',
    error: 'Ошибки',
    errorPercents: 'Ошибки %',
    return: 'Возвраты',
    returnPercents: 'Возвраты %',
    paid: 'Оплачено',
    paidPercents: 'Оплачено %',
    in_total: 'Итого',
    webmaster: 'Веб-мастер',
    proportion: 'Доля',
    buyoutSum: 'Выкуплено',
    acceptedSum: 'Одобрено',
    worked: 'Отработано',
    operator: 'Оператор',
    processed_leads: 'Обработано лидов',
    points: 'Баллы',
    operators: 'Операторы',
    actions: 'Действия',
    courier: 'Курьер',
    shipped: 'Отправлено',
    couriers: 'Курьеры',
    transit: 'В пути',
    delivered: 'Доставлено',
    averageBillPopup: 'Средний чек',
    buyout: 'Выкуп',
    additional_sale: 'Доп. продаж',
    old_bonus: 'Бонус',
    revenue_lead: 'Выручка на лид',
    total_revenue: 'Выручка всего',
    deviation_mean: 'Отклонение от среднего',
    new_bonus: 'Новый бонус',
    bonus_system: 'Система бонусов',
    exporting_history: 'История экспорта',
    period: 'Период',
    paid_bonus: 'Выплаченный бонус',
    system_bonus: 'Бонус по системе',
    loading_error: 'Ошибка при загрузке данных. Попробуйте еще раз.',
    reason: 'Причина',
    week: 'Неделя',
    difference: 'Разница',
    debt: 'Рекламный долг',
    delay_debt: 'Просрочка по рекламному долгу',
    country: 'Страна',
    to_pay_for_today: 'К выплате за сегодня',
    payout_for_the_week: 'К выплате за неделю',
    last_payout: 'Последняя выплата',
    cancel_title: 'Причина отмены',
    cancel_count: 'Отмены',
    return_title: 'Причина возврата',
    return_count: 'Возвраты',
    refundsId: 'ID',
    AcceptCancel: 'Принят ⇒ Отменен',
    CancelAccept: 'Отменен ⇒ Принят',
    ProcessAccept: 'Обработка ⇒ Принят',
    ProcessCancel: 'Обработка ⇒ Отменен',
    ProcessSpam: 'Обработка ⇒ Спам',
    SpamAccept: 'Спам ⇒ Принят',
    spam: 'Спам',
    average_payment: 'Средняя выплата за период',
    last_payment: 'Фактическая выплата',
    payment_fix: 'Установленная выплата',
    fix_to: 'Стало',
    fix_from: 'Было',
    payment_history: 'История изменений',
    vat: 'VAT',
    out: 'Вывод',
    profitlid: 'ПРОФИТ с 1 лида',
    profitperiod: 'ПРОФИТ за период',
    packaging: 'Упаковка',
    shippeds: 'В доставке',
    average_payments: 'Выплата вебу',
    user: 'Пользователь',
    product: 'Товар',
    products: 'Товары',
    balance: 'Остаток на складе',
    unloaded_leads: 'Выгружено лидов за месяц',
    unloaded_product: 'Выгружено товаров за месяц',
    delays_leads: 'Задержки Лидов',
    delays_product: 'Задержки Товаров',
    stock_product: 'Запас Дней',
    order_product: 'Заказ Товара',
    comment: 'Комментарий',
    price: 'Цена',
    project: 'Проект',
    balance_on_the_first_day_of_the_month: 'Остаток на 1-е число',
    total_money: 'Сумма',
    logistic: 'Логистика',
    customs: 'Растаможка',
    price_for_one: 'Цена за единицу',
    provider: 'Поставщик',
    time: 'Срок поставки',
    times: 'Дата поставки',
    status: 'Статус',
    ordered: 'Заказано',
    credit: 'Долг',
    shift: 'Изменения',
    by_graph: 'График динамики ключевых показателей',
    manager: 'Менеджер',
    expiration_date: 'Cрок годности',
    stagnation_date: 'Cколько дней задержка',
    time_success_call: 'Cреднее время до успешного звонка',
    time_recall: 'Cреднее время до перезвона',
    approve_percent: 'Количество апрувов',
    expenses_by_lead: 'Расход на лид',
    expected_lead_increase: 'Ожидаемое увеличения расхода на лид',
    cost_change: 'Изменение расхода',
    month: 'Месяц',
    sets: 'Сеты',
    city: 'Город',
    cost_price: 'Себестоимость',
    total_all: 'Сумма всего',
    total_sms_sent: 'Всего отправленных смс',
    total_lead_sms_sent: 'Отправленные смс на 1 лид',
    total_sms: 'Сумма на 1 смс',
    total_minutes: 'Сумма минут звонков',
    total_all_minutes: 'Сумма всего',
    total_minutes_lead: 'Минут на 1 лид',
    total_lead: 'Сумма на 1 лид',
    total_seconds_call: 'Сумма СМС и звонков на 1 лид',
    country_id_web: 'Страны вебмастера',
    offer_id_web: 'Проекты вебмастера',
    dialer: '% Дозвона',
    average_first_call_time: 'Среднее время первого звонка',
    average_number_touches: 'Среднее количество касаний',
    average_calls: 'Среднее количество звонков',
    active_operators: 'Количество активных операторов',
    one_day_dialer: 'Дозвон на 1 день',
    new_orders: 'Новых заказов',
    sending_check: 'Чек отправки',
    foreclosure_check: 'Чек выкупа',
    call_duration: 'Длительность разговора',
    call_duration_approve: 'Длительность разговора апрувов',
    call_duration_cancel: 'Длительность разговора отмен',
    time_processing: 'Время обработки',
    time_out_calls: 'Время вне звонков',
    total_cancel: 'Всего отмен',
    processed_all: 'Обработано всего',
    another: 'Другое',
    expensive: 'Дорого',
    not_order: 'Не заказывал',
    changed_mind: 'Передумал',
    bad_reputation: 'Плохая репутация продукта/компании',
    consultation: 'Сделал заявку, чтобы получить консультацию',
    not_allowed: 'Муж, жена, родственники не разрешают',
    medical_contraindications: 'Медицинские противопоказания',
    not_ringing_long_time: 'Недозвон в течении долгого времени',
    not_make_contact: 'Не идёт на контакт бросает трубку агрессивно реагирует',
    no_coverage: 'Нет покрытия',
    blacklisted_customer: 'Клиент в черном списке',
    not_delivery_time: 'Не успеваем доставить вовремя',
    already_bought: 'Уже купил',
    suite_different_price: 'На сайте другая цена',
    any_reasons: 'Без причины',
    template_sms: 'Шаблон СМС',
    parts_sms: 'Кол-во частей СМС',
    sent_sms: 'Кол-во отправленных СМС',
    total_amount: 'Итоговая сумма',
    approvals: 'Кол-во апрувов',
    cross_sell_cost: 'Стоимость кроссейла',
    orders_accepted: 'Принятые заказы',

    no_payment_method: 'Не устраивает способ оплаты (карта/наличные)',
    form_release: 'Не нравится форма выпуска продукта (клиент выслушал оператора и ему не нравится форма выпуска)',
    want_guarantees: 'Клиент хочет получить информацию о гарантиях и возврате денег',
    not_processed: 'Заказы не могут быть обработаны в данный момент. (зп в след месяце, клиент в другом городе)',
    expensive_delivery: 'Дорогая доставка',
    no_pay_tax: 'Не хочет платить налог',
    no_nearby: 'Отвечает третье лицо, нет заказчика рядом',
    other_information: 'На сайте другая информация',
    won_gift: 'Клиент думал что выиграл подарок (или бесплатную упаковку)',
    language_barrier: 'Языковой барьер',
    wrong_data: 'Не верный номер, не туда попали',
    drop_calls: 'Клиент скидывает звонок / не может быть подтвержден',
    silent: 'Клиенты молчат и не разговаривают',
    under_18: 'Клиент младше 18 лет'
  },
  filters: {
    clean: 'Очистить',
    select_all: 'Выбрать все',
    reset: 'Сбросить',
    more_pre: 'еще ',
    more_post: '',
    apply: 'Применить',
    reset_all: 'Сбросить все',
    yesterday: 'Вчера',
    week: 'Неделя',
    this_month: 'Этот месяц',
    last_month: 'Прошлый месяц',
    copy_filter: 'Скопировать фильтр',
    filter_copied: 'Фильтр скопирован',
    filter_copied_error: 'Ошибка копирования',
    period: 'Период',
    by_wm: 'По web1',
    by_manual: 'По manual'
  },
  country: {
    '1528': 'Вьетнам',
    '1534': 'Египет',
    '1522': 'Индия',
    '1536': 'Иран',
    '1529': 'Индонезия',
    '1527': 'Марокко',
    '1525': 'Малайзия',
    '1537': 'Нигерия',
    '1531': 'PRO Пакистан',
    '1535': 'Россия 2',
    '77': 'Россия',
    '1532': 'Таиланд 4',
    '1526': 'Турция 2',
    '1530': 'Таиланд 3',
    '1533': 'Филиппины 2',
    '1524': 'Филиппины',
    '1538': 'Тунис',
    '1539': 'Индонезия 2',
    '1540': 'Европа',
    '1541': 'Тест',
    '1542': 'Колумбия',
    '1543': 'Алжир',
    '1544': 'Мьянма',
    '1545': 'ОАЭ',
    '1546': 'Сингапур',
    '1547': 'Россия 3',
    '1548': 'GreenGo',
    '1549': 'Индия 2',
    '1550': 'Перу',
    '1551': 'PRO Индия',
    '1552': 'PRO Индонезия',
    '1553': 'PRO Малайзия',
    '1554': 'PRO Филиппины',
    '1555': 'PRO Вьетнам',
    '1556': 'PRO Тунис',
    '1557': 'PRO Колумбия',
    '1558': 'PRO Россия',
    '1559': 'PRO Украина',
    '1560': 'PRO Казахстан',
    '1561': 'PRO Нигерия',
    '1562': 'Тестовый',
    '1563': 'PRO Тайланд',
    '1564': 'PRO Ирак',
    '1565': 'PRO ЮАР',
    '1566': 'PRO Венесуэла',
    '1567': 'PRO Аргентина',
    '1568': 'PRO Чили',
    '1569': 'PRO Уругвай',
    '1570': 'PRO Эквадор',
    '1573': 'PRO Марокко',
    '1571': 'PRO Перу',
    '1572': 'PRO Мьянма',
    '1575': 'Камбоджа',
    '1574': 'PRO Мексика',
    '1576': 'PRO Бангладеш',
    '1577': 'PRO Россия Мск',
    '1579': 'PRO Россия Рязань',
    '1578': 'Конго',
    '1581': 'PRO Лаос',
    '1582': 'PRO Европа',
    '1585': 'PRO Кения',
    '1580': 'PRO Шри-Ланка',
    '1583': 'PRO Узбекистан',
    '1584': 'PRO Непал',
    '1586': 'PRO Танзания',
    '1587': 'PRO Австралия',
    '1588': 'Тест 2',
    '1589': 'Мьянма 2',
    '1590': 'Pro Египет',
    '1591': 'PRO Мьянма 2',
    '1592': 'PRO Индонезия 2',
    '1593': 'PRO Индия 2',
    '1594': 'Колумбия 2',
    '1595': 'PRO Мексика 2',
    '1596': 'PRO Колумбия 2',
    '1597': 'GGTeam',
    '1598': 'PRO Казахстан 2',
    '1599': 'PRO Гватемала',
    '1600': 'PRO Сингапур',
    '1601': 'Чили',
    '1602': 'Пакистан',
    '1603': 'Эфиопия',
    '1604': 'Эквадор',
    '1605': 'США',
    '1606': 'Иран 1',
    '1608': 'For tests',
    '1609': 'PRO Алжир',
    '1610': 'Шри-Ланка',
    '1611': 'PRO Коста-Рика',
    '1612': 'PRO Доминикана',
    '1613': 'PRO Египет 2',
    '1614': 'PRO Гондурас',
    '1615': "PRO Кот-д'Ивуар",
    '1616': 'PRO Иордания',
    '1617': 'PRO Нигерия 2',
    '1618': 'PRO ЮАР 2',
    '1619': 'PRO Боливия',
    '1620': 'PRO Кения 2',
    '-1': 'Все страны'
  },
  return_reason: {
    1: 'VERY_EXPENSIVE',
    2: 'CHANGED_ONES_MIND',
    3: 'DELIVERY_TOOK_TO_LONG',
    4: 'BAD_QUALITY_OF_PACKAGE',
    5: 'COURIER_INCREASED_AMOUNT',
    6: 'NO_NOTIFICATION_FROM_COURIER',
    7: 'RUDE_COURIER',
    8: 'NO_DELIVERED_AFTER_FIRST_ATTEMPT',
    9: 'CUSTOMER_OUTSIDE_OF_CITY',
    10: 'DELIVERED_BOY_DID_NOT_CAME',
    11: 'PIN_CODE_MISTAKE',
    12: 'CUSTOMER_IS_NOT_AVAILABLE',
    13: 'BOUGHT_ANOTHER_PRODUCT',
    14: 'MONEY_PROBLEM',
    15: 'CAN_NOT_OPEN_PARCEL',
    16: 'CAN_NOT_PAY_VIA_CREDIT_CARD'
  },
  pages: {
    statistic: 'Статистика',
    refunds: 'Возвраты',
    ref_cancel: 'Статистика по отменам',
    ref_return: 'Статистика по возвратам',
    ref_cancel_by_month: 'Статистика по отменам по месяцам',
    ref_return_by_month: 'Статистика по возвратам по месяцам',
    ref_cancel_operators: 'Статистика по отменам операторов',
    webmasters: 'Источники',
    dashboard: 'Главная',
    analytics: 'Аналитика',
    conversions: 'Статистика',
    by_country: 'По стране',
    by_offers: 'По офферам',
    by_category_product: 'По категориям товаров',
    by_balance_currency: 'Валюта баланс',
    by_period: 'За период',
    operators: 'ЦОК',
    efficiency: 'Эффективность',
    activity: 'Активность',
    buyout: 'Выкупаемость',
    return_reason: 'Причины возврата',
    by_couriers: 'По курьеркам',
    by_graph: 'По ключевым показателям',
    by_weeks: 'По неделям',
    by_days: 'По дням',
    by_month: 'По месяцам',
    by_pieces: 'По штукам',
    changelog: 'История версий',
    changeversion: 'Версии',
    order: 'Обработка заказов',
    conversion: 'Конверсии',
    new_orders: 'Новые заказы',
    operator_conversions: 'Статистика конверсии у операторов',
    individual_rates: 'Индивидуальные рейты',
    webmaster_statistic: 'Cтатистика по вебам',
    webmaster_individual_rates: 'Статистика по индивидуальным рейтам вебмастеров',
    offer: 'Оффер',
    offer_rent: 'Рентабельность офферов',
    orders: 'Заказы',
    receipt: 'Приходы',
    remnants: 'Остатки',
    product: 'Товары',
    source_statistic: 'Статистика по сорсам',
    sources: 'Sources',
    rentability: 'Рентабельность',
    expenses_by_kc: 'Расходы по КЦ',
    timing_kc: 'Тайминг работы КЦ',
    call_statistics: 'Статистика по звонкам',
    operators_analysis: 'Операторы',
    ringing_sms: 'СМС и Робопрозвон',
    sent_sms_template: 'Отправленные СМС шаблоны',
    ringing_holds: 'Прозвон холдов',
    cross_sell: 'Кроссейл',
    landing: 'Landing',
    landing_statistic: 'Статистика по лендам',
    arrival_new_leads: 'Поступление новых лидов',
    grid_statistic: 'Статистика по сеткам',
    web_analysis: 'Анализ',
    approved_during_the_day: 'Апрув в течение дня',
    orders_receipt: 'Заказы/Приходы',
    buyouts_flypost: 'Выкупы флайпост',
    new_orders_week: 'За неделю',
    webmasters_notify: 'Вебмастеры успешно скопированы'
  },
  profile: {
    gravatar_change_avatar: 'Вы можете сменить свой аватар на сайте ',
    avatar: 'Аватар',
    security: 'Безопасность',
    change_password: 'Сменить пароль',
    first_name: 'Имя',
    last_name: 'Фамилия',
    email: 'Email',
    personal_information: 'Персональная информация',
    password_error_9: 'Длина пароля должна быть не менее 6 символов',
    password_error_8: 'Пароли не совпадают',
    password_error_10: 'Неверный пароль',
    password_changed: 'Пароль сменен',
    need_all: 'Пожалуйста,',
    updated: 'Профиль обновлен',
    language: 'Язык',
    language_changed: 'Язык сменен',
    for_developer: 'Для разработчиков',
    developer_mode: 'Режим разработчика'
  },
  month: {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ru.js